var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "detailPanel",
    style: {
      height: _vm.height + "px"
    }
  }, [_vm.model.clazz === "userTask" ? _c("UserTaskDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly,
      users: _vm.users,
      authorities: _vm.authorities,
      groups: _vm.groups
    }
  }) : _vm.model.clazz === "scriptTask" ? _c("ScriptTaskDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "receiveTask" ? _c("ReceiveTaskDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "mailTask" ? _c("MailTaskDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "timerStart" || _vm.model.clazz === "timerCatch" ? _c("TimerEventDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "messageStart" || _vm.model.clazz === "messageCatch" ? _c("MessageEventDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly,
      messageDefs: _vm.messageDefs
    }
  }) : _vm.model.clazz === "gateway" || _vm.model.clazz === "exclusiveGateway" || _vm.model.clazz === "parallelGateway" || _vm.model.clazz === "inclusiveGateway" ? _c("GatewayDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "flow" ? _c("FlowDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "start" ? _c("StartEventDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "end" ? _c("EndEventDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly
    }
  }) : _vm.model.clazz === "process" ? _c("ProcessDetail", {
    attrs: {
      model: _vm.model,
      onChange: _vm.onChange,
      readOnly: _vm.readOnly,
      categorys: _vm.categorys
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };